import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import '../assets/styles/settings.css';
import '../assets/styles/docs.scss';
import '../assets/styles/dashboard.scss';
import { BulletinBoard } from './BulletinBoard';
import { Permissions } from './Permissions';
import { DocsList } from './DocsList';
import { notificationActions, permissionActions } from '../_actions';
import { userActions } from '../_actions';
import moment from 'moment';
import ChangePassword from 'ChangePassword';
import ChangeStatusModal from '_components/ChangeStatusModal';
import HandBookView from './HandBookView';
import SystemManage from './SystemManage';
import { userService } from '_services/user.service';
import { toast } from 'react-toastify';
import { handleErrorResponse } from '_helpers/helpers';
import ViewProfile from '_components/Profile/ViewProfile';
import { authHeader, config } from '../_helpers';
import { Link } from 'react-router-dom';

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainHtml: '',
      step: this.props.match.params.step,
      statusOpen: false,
      status: '',
      available: '',
      statusStep: '1',
      returnDateField: moment(),
      returnDate: '',
      permission: [],
      h1: '',
      showHandBookView: false,
      sendingDDForm: false,
      send_dd_form_confirm: false,
      reloadKey: 0,
      loader: false,
      mailSendOpen: false,
      message: '',
      alertPop: false,
      alertHead: '',
      alertMsg: '',
      alertFunction: '',
    };
    this.changeTab = this.changeTab.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.setStatusReturn = this.setStatusReturn.bind(this);
    this.setStep = this.setStep.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.cancel = this.cancel.bind(this);
    this.editProfile = this.editProfile.bind(this);
  }

  changeStepParam = (newStep) => {
    const { history, match } = this.props;
    history.replace(`/settings/${newStep}`);
  };

  openDdformConfirmModal() {
    this.setState({ send_dd_form_confirm: true });
  }

  ddFormConfirmCloseModal() {
    this.setState({
      send_dd_form_confirm: false,
    });
  }

  sendDDForm() {
    if (this.props.user.items.data.hash) {
      this.setState({
        ...this.state,
        sendingDDForm: true,
        send_dd_form_confirm: false,
      });
      let data = new FormData();
      data.append('user_hash', this.props.user.items.data.hash);
      userService
        .sendDDForm(data)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            handleErrorResponse(res);
          }
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        })
        .catch((error) => {
          toast.error('Failed to send email to user.');
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        });
    } else {
      toast.error('An unexpected error occurred.');
    }
  }

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  statusCloseModal() {
    this.setState({ statusOpen: false });
  }

  changeTab(tab) {
    this.changeStepParam(tab);
    this.setState({ step: tab }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  setStatusReturn(status) {
    if (status) {
      var step = '2a';
    } else step = '2b';

    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }
  setStep(step) {
    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  handleDateChange(date) {
    this.setState({
      returnDateField: date,
      returnDate: date.format('MM/DD/YY'),
    });
  }

  changeStatus(status, statVal) {
    if (status) {
      var stat = statVal === 'Available' ? 'Unavailable' : 'Available';
      this.setState({ status: stat, loader: true }, function () {
        this.componentWillReceiveProps(this.props);
      });

      let data = new FormData();
      this.statusCloseModal();

      data.append('hash', this.props.match.params.hash);
      data.append('end_date', this.state.returnDate);
      data.append('status', stat);

      var hash = '?hash=' + this.props.match.params.hash;
      if (this.props.match.params.hash === localStorage.getItem('hash')) {
        this.props.dispatch(userActions.changeSelfStatus(data));
      } else {
        this.props.dispatch(userActions.changeStatus(data, hash));
      }

      this.props.dispatch(notificationActions.getCount());
    }
  }

  editProfile() {
    this.setState({ step: 'EditProfile' }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }
  cancel() {
    this.setState({ step: 'Profile' }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  // Message functionality methods
  mailSendOpenModal() {
    this.setState({ mailSendOpen: true });
  }

  mailSendCloseModal() {
    this.setState({ mailSendOpen: false });
  }

  sendMail() {
    let data = new FormData();
    this.mailSendCloseModal();
    data.append('type', 'mail');
    data.append('message', this.state.message);
    data.append('user_hash', this.props.user?.profile?.data?.hash);

    var self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  componentDidMount() {
    var hash = '';
    if (this.props.match.params.hash) {
      var hash = '?hash=' + this.props.match.params.hash;
    }
    this.props.dispatch(userActions.getProfile(hash));
    this.componentWillReceiveProps(this.props);
    this.props.dispatch(permissionActions.getPermission());
    if (this.props.match.path === '/profile/:hash/docs/:category/:doc/:id') {
      this.changeTab('docs-list');
    }
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;
    if (user?.changeStatusSuccess && !prevProps.user?.changeStatusSuccess) {
      this.statusCloseModal();
      this.setState({ reloadKey: this.state.reloadKey + 1, loader: false });
    }

    if (user?.changeStatusFailure && !prevProps.user?.changeStatusFailure) {
      this.statusCloseModal();
      this.setState({ loader: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { permission } = this.props;
    if (permission.permissions) {
      this.setState({ permission: permission.permissions.data });
    }

    if (nextProps.user.items?.data) {
      var admin = nextProps.user.items.data.is_admin !== 0 ? true : false;
      if (
        this.props.match.path === '/profile/:hash/:step' ||
        this.props.match.path === '/profile/:hash/docs/:category/:doc/:id'
      ) {
        this.setState({
          h1:
            nextProps.user.items.data.first_name +
            ' ' +
            nextProps.user.items.data.last_name,
          admin,
          namePrefix: nextProps.user.items.data.first_name,
        });
      } else {
        this.setState({ h1: 'Profile & Settings', admin, namePrefix: 'you' });
      }
      var available =
        nextProps.user.items.data.active === 'Available' ? true : false;
      this.setState({
        status: nextProps.user.items.data.active,
        available: available,
      });
    }
    var options;
    if (this.state.step === 'profile') {
      options = (
        <div>
          <ViewProfile
            userHash={this.props.user?.profile?.data?.hash}
            authUser={this.props.user?.profile?.data}
            permList={this.state.permission}
            changeTab={this.changeTab}
            reloadKey={this.state.reloadKey}
          />
        </div>
      );
    }
    if (this.state.step === 'docs-list') {
      options = (
        <div>
          <DocsList />
        </div>
      );
    }
    if (this.state.step === 'bulletin') {
      options = (
        <div>
          <BulletinBoard />
        </div>
      );
    }
    if (this.state.step === 'permissions') {
      options = (
        <div>
          <Permissions />
        </div>
      );
    }
    if (this.state.step === 'system-management') {
      options = (
        <div>
          <SystemManage />
        </div>
      );
    }

    this.setState({ mainHtml: options });
  }
  handleHandBookView() {
    this.setState((prev) => ({ showHandBookView: !prev.showHandBookView }));
  }

  //
  render() {
    const { permission, user } = this.props;
    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }

    var admin = false,
      editPerm = true,
      userItem;

    if (this.props.user.profile) {
      userItem = this.props.user.profile;
    } else if (this.props.user.items) {
      userItem = this.props.user.items;
    }

    var namePrefix = '';
    let userData = user.profile ? user.profile.data : {};

    if (userItem) {
      var status = userItem.data.active;
      var available = userItem.data.active === 'Available' ? true : false;
      admin = userItem.data.is_admin !== 0 ? true : false;
      var h1 = 'Settings';
      namePrefix = 'you';

      if (userData?.id != userItem?.data?.id) {
        h1 = userItem.data.first_name + ' ' + userItem.data.last_name;
        editPerm = permList.includes('Status Update') ? true : false;
        namePrefix = this.state.namePrefix;
      }
    }

    return (
      <div>
        <div>
          <div className="settings_container settings-pre-wrapper">
            {this.state.showHandBookView ? (
              <HandBookView
                onCancel={() => this.handleHandBookView()}
                fileUrl={userData?.handbook_link}
              />
            ) : (
              <React.Fragment>
                <div className="breadcrumbs">
                  <Link to={'/settings'} className="green">
                    Settings
                  </Link>{' '}
                  / Profile
                </div>
                <div className="page_title float">
                  <h1 className="">{this.state.h1}</h1>

                  <div className="btn_list">
                    {permList.includes('Manage Passwords') && (
                      <ChangePassword
                        userType="user"
                        user={userItem?.data}
                        isAdmin={
                          this.props?.user?.profile?.data?.is_admin !== 0
                            ? true
                            : false
                        }
                      />
                    )}
                    <button
                      className="button"
                      onClick={() => window.print()}
                    >
                      Print
                    </button>
                    {permList.includes('Message Employees') && (
                      <button
                        className="button"
                        onClick={this.mailSendOpenModal.bind(this)}
                      >
                        Message
                      </button>
                    )}
                    {editPerm && (
                      <button
                        className="button"
                        onClick={this.statusOpenModal.bind(this)}
                      >
                        Edit Status
                      </button>
                    )}
                    {permList.includes('Send DD Form') && (
                      <button
                        className="button"
                        onClick={this.openDdformConfirmModal.bind(this)}
                        disabled={this.state.sendingDDForm}
                      >
                        Send DD Form
                      </button>
                    )}
                    {userData?.handbook_link ? (
                      <button
                        className="button"
                        onClick={() => this.handleHandBookView()}
                      >
                        View Handbook
                      </button>
                    ) : null}
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="inner_head">
                      <h2
                        className={
                          this.state.step === 'profile' ? 'active' : ''
                        }
                        onClick={this.changeTab.bind(this, 'profile')}
                      >
                        Profile
                      </h2>
                      {
                        <h2
                          className={
                            this.state.step === 'docs-list' ? 'active' : ''
                          }
                          onClick={this.changeTab.bind(this, 'docs-list')}
                        >
                          Documents
                        </h2>
                      }
                          {admin &&
                            this.props.match.path !== '/profile/:hash' &&
                            this.props.match.path !==
                              '/profile/:hash/docs/:category/:doc/:id' && (
                              <h2
                                className={
                                  this.state.step === 'permissions'
                                    ? 'active'
                                    : ''
                                }
                                onClick={this.changeTab.bind(
                                  this,
                                  'permissions'
                                )}
                              >
                                Permissions
                              </h2>
                            )}
                      {this.state.permission.includes('Bulletin Board') &&
                        this.props.match.path !== '/profile/:hash' &&
                        this.props.match.path !==
                          '/profile/:hash/docs/:category/:doc/:id' && (
                          <h2
                            className={
                              this.state.step === 'bulletin' ? 'active' : ''
                            }
                            onClick={this.changeTab.bind(this, 'bulletin')}
                          >
                            Bulletin Board
                          </h2>
                        )}
                      {admin &&
                        this.state.permission.includes(
                          'Bypass Employee Application'
                        ) && (
                          <h2
                            className={
                              this.state.step === 'system-management'
                                ? 'active'
                                : ''
                            }
                            onClick={this.changeTab.bind(
                              this,
                              'system-management'
                            )}
                          >
                            System Management
                          </h2>
                        )}
                    </div>
                    <div className="tab-contents">{this.state.mainHtml}</div>
                  </div>
                </div>
                {this.state.statusOpen ? (
                  <ChangeStatusModal
                    open={this.state.statusOpen}
                    onClose={this.statusCloseModal}
                  />
                ) : null}

                <Modal
                  id="remove_popup"
                  className="status_popup"
                  open={this.state.send_dd_form_confirm}
                  onClose={this.ddFormConfirmCloseModal.bind(this)}
                  little
                >
                  <div id="removePopup">
                    <div className="modal-head">
                      <h4 className="modal-title">Direct Deposit Form</h4>
                    </div>
                    <div className="modal-body">
                      <label>
                        This will send an email to{' '}
                        {userData
                          ? userData.first_name + ' ' + userData.last_name
                          : 'this employee'}
                        , with Direct Deposit form link.
                      </label>
                      <br />
                      <button
                        className="button grey"
                        onClick={this.ddFormConfirmCloseModal.bind(this)}
                      >
                        Cancel
                      </button>
                      <button
                        className="button"
                        onClick={this.sendDDForm.bind(this)}
                      >
                        Send
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal
                  id="email_popup"
                  className="status_popup"
                  open={this.state.mailSendOpen}
                  onClose={this.mailSendCloseModal.bind(this)}
                  little
                >
                  <div id="emailPopup">
                    <div className="modal-head">
                      <h4 className="modal-title">Custom Message</h4>
                    </div>
                    <div className="modal-body">
                      <textarea
                        name="message"
                        cols="80"
                        rows="10"
                        value={this.state.message}
                        onChange={(e) => this.setState({ message: e.target.value })}
                      />
                      <p className="step_no">
                        Signature will automatically be included.
                      </p>
                      <button
                        className="button grey"
                        onClick={this.mailSendCloseModal.bind(this)}
                      >
                        Cancel
                      </button>
                      <button
                        className="button"
                        onClick={this.sendMail.bind(this)}
                      >
                        Send
                      </button>
                    </div>
                  </div>
                </Modal>
                {this.state.alertPop && (
                  <div className="alert-popup">
                    <div className="alert-content">
                      <h4>{this.state.alertHead}</h4>
                      <p>{this.state.alertMsg}</p>
                      <button
                        className="button"
                        onClick={() => this.setState({ alertPop: false })}
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { applicants, user, permission } = state;
  return {
    applicants,
    user,
    permission,
  };
}
const connectedHomePage = connect(mapStateToProps)(Settings);
export { connectedHomePage as Settings };
